export enum CBID {
  GDPR = 'cdf04a99-d788-4cc7-a211-288366052e68',
  USCalifornia = 'b7c911df-cb94-446d-97f7-2ab440730921',
  USConnecticut = '0da885a4-a5be-470b-a5ab-a4bea9130b80',
}

export enum EEACountryCodes {
  Belgium = 'BE',
  Bulgaria = 'BG',
  Czechia = 'CZ',
  Denmark = 'DK',
  Germany = 'DE',
  Estonia = 'EE',
  Ireland = 'IE',
  Greece = 'GR',
  Spain = 'ES',
  France = 'FR',
  Croatia = 'HR',
  Italy = 'IT',
  Cyprus = 'CY',
  Latvia = 'LV',
  Lithuania = 'LT',
  Luxembourg = 'LU',
  Hungary = 'HU',
  Malta = 'MT',
  Netherlands = 'NL',
  Austria = 'AT',
  Poland = 'PL',
  Portugal = 'PT',
  Romania = 'RO',
  Slovenia = 'SI',
  Slovakia = 'SK',
  Finland = 'FI',
  Sweden = 'SE',
  Iceland = 'IS',
  Liechtenstein = 'LI',
  Norway = 'NO',
}

export enum GDPRCompliantCountryCodes {
  Switzerland = 'CH',
  UnitedKingdom = 'GB',
}

export enum USStateRegionCodes {
  California = 'US-06',
  Connecticut = 'US-09',
}

export const GDPR_COMPLIANT = Object.values({
  ...EEACountryCodes,
  ...GDPRCompliantCountryCodes,
});
